import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ModalHeader, ScrollableContent, ModalContainer, ModalContent, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ModalSectionTitle, } from "../Styles/InputStyles";
import { allDocumentTypes, getDueTypeLabel, getModeName, getOrdinalNumber } from "../../helpers";
import { Link } from "react-router-dom";
import ModalProfileHeader from "../Common/ModalProfileHeader";
import { capitalizeFirstLetter } from "../../helpers";
import Config from "../../Config";

const TenantDetailsModal = ({
    onClose,
    tenant,
    onNext,
    onPrevious,
    hasNext,
    hasPrevious,
    loadPaymentLinkModal,
    loadingId,
    isLoading
}) => {
    const uploadedDocuments = tenant?.docs || [];

    const showPaymentLinkModal = (item, e) => {
        loadPaymentLinkModal(item, e);
    };
    const profilePicture = tenant?.docs?.find((tenant) => tenant.type === 4);
    const documents = allDocumentTypes
        .map((type) => {
            const matchedDoc = uploadedDocuments.find(
                (doc) =>
                    Number(doc?.type) === Number(type?.key)
            );

            if (!matchedDoc) return null;

            return {
                label: matchedDoc?.title || type.label,
                file: matchedDoc?.value,
                uploadedAt: matchedDoc?.createdAt,
                verified: matchedDoc?.status === 2,
            };
        })
        .filter(Boolean)
        .filter((doc) => doc?.file);

    if (isLoading || !tenant) {
        return (
            <div className="h-full min-h-screen bg-white animate-pulse">

                {/* Header */}
                <div
                    className="sticky top-0 z-20
                flex items-center justify-between
                px-5 py-4
                bg-white border-b border-gray-100"
                >
                    {/* Left */}
                    <div className="flex items-center gap-2">
                        <div className="h-10 w-24 rounded-xl bg-gray-200" />
                        <div className="h-10 w-20 rounded-xl bg-gray-200" />
                    </div>

                    {/* Right */}
                    <div className="flex items-center gap-2">
                        <div className="h-10 w-32 rounded-xl bg-gray-200" />
                        <div className="h-10 w-10 rounded-xl bg-gray-200" />
                    </div>
                </div>

                {/* Body */}
                <div className="p-5 space-y-6">

                    {/* Profile Header */}
                    <div className="bg-[#F8F8F5] rounded-3xl p-5">
                        <div className="flex items-center gap-4">

                            <div className="h-16 w-16 rounded-2xl bg-gray-200" />

                            <div className="flex-1">
                                <div className="h-5 w-48 bg-gray-200 rounded-md" />

                                <div className="h-4 w-64 bg-gray-100 rounded-md mt-3" />
                            </div>

                            <div>
                                <div className="h-8 w-24 bg-gray-300 rounded-xl" />
                            </div>
                        </div>
                    </div>

                    {/* Summary Section */}
                    <div>
                        <div className="h-5 w-40 bg-gray-200 rounded-md mb-4" />

                        <div className="grid grid-cols-2 gap-4">
                            {[1, 2, 3, 4].map((item) => (
                                <div
                                    key={item}
                                    className="bg-[#F8F8F5]
                                rounded-2xl p-4"
                                >
                                    <div className="h-4 w-24 bg-gray-200 rounded-md" />

                                    <div className="h-7 w-20 bg-gray-300 rounded-md mt-4" />
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Dues */}
                    <div>
                        <div className="h-5 w-36 bg-gray-200 rounded-md mb-4" />

                        <div className="bg-[#F8F8F5] rounded-3xl overflow-hidden">
                            {[1, 2, 3].map((item) => (
                                <div
                                    key={item}
                                    className="flex items-center justify-between px-5 py-4 border-b border-[#E7E5DF]"
                                >
                                    <div>
                                        <div className="h-4 w-40 bg-gray-200 rounded-md" />
                                        <div className="h-3 w-24 bg-gray-100 rounded-md mt-2" />
                                    </div>

                                    <div className="flex flex-col items-end">
                                        <div className="h-6 w-20 bg-gray-300 rounded-md" />
                                        <div className="h-4 w-16 bg-gray-100 rounded-md mt-2" />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Documents */}
                    <div>
                        <div className="h-5 w-32 bg-gray-200 rounded-md mb-4" />

                        <div className="bg-[#F8F8F5] rounded-3xl overflow-hidden">
                            {[1, 2].map((item) => (
                                <div
                                    key={item}
                                    className="flex items-center justify-between px-5 py-4 border-b border-[#E7E5DF]"
                                >
                                    <div className="flex items-center gap-4">
                                        <div className="h-12 w-12 rounded-2xl bg-gray-200" />

                                        <div>
                                            <div className="h-4 w-32 bg-gray-200 rounded-md" />
                                            <div className="h-3 w-24 bg-gray-100 rounded-md mt-2" />
                                        </div>
                                    </div>

                                    <div className="h-8 w-20 bg-gray-300 rounded-full" />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <Container>
            {/* Header */}
            <div
                className="sticky top-0 z-20 flex items-center justify-between px-5 py-4 bg-primary-color border-b border-gray-100"
            >
                {/* Left Navigation */}
                <div className="flex items-center gap-2">
                    <button
                        onClick={onPrevious}
                        disabled={!hasPrevious}
                        className={`h-10 px-4 rounded-xl flex items-center gap-2 text-sm font-medium transition-all ${hasPrevious ? "bg-gray-100 text-gray-700 hover:bg-gray-200" : "bg-gray-50 text-gray-300 cursor-not-allowed"}`}
                    >
                        <span>←</span>
                        Previous
                    </button>

                    <button
                        onClick={onNext}
                        disabled={!hasNext}
                        className={`h-10 px-4 rounded-xl flex items-center gap-2 text-sm font-medium transition-all ${hasNext ? "bg-blue-50 text-primary-color hover:bg-gray-200" : "bg-gray-100 text-gray-300 cursor-not-allowed"}`}
                    >
                        Next
                        <span>→</span>
                    </button>
                </div>

                {/* Right Actions */}
                <div className="flex items-center gap-2">
                    <Link
                        to={`/tenantdetails/l/${tenant?.id}`}
                        // target="_blank"
                        rel="noopener noreferrer"
                        className="h-10 px-4 rounded-xl border border-gray-200 bg-white flex items-center gap-2 text-sm font-medium text-gray-700 hover:bg-gray-50 transition-all"
                    >
                        Open Profile
                        <span className="text-sm">↗</span>
                    </Link>

                    <button
                        onClick={onClose}
                        className="h-10 w-10 rounded-xl bg-gray-100 flex items-center justify-center text-gray-600 hover:bg-gray-200 transition-all"
                    >
                        <MdClose size={20} />
                    </button>
                </div>
            </div>

            <ModalProfileHeader
                title="Due Details"
                name={capitalizeFirstLetter(tenant?.name)}
                subtitle={`#${tenant?.occupancy?.roomNum} • ${tenant?.occupancy?.flatName || ""} • ${tenant?.occupancy?.propName}`}
                amountLabel={"Amount Due"}
                amount={tenant?.totalDues}
                image={profilePicture?.value || ''}
                onClose={onClose}
            />

            {/* ModalContent */}
            <ModalContent>
                <ScrollableContent>
                    <Wrapper>
                        {/* Rental Summary */}
                        <BtnWrapper>
                            <ModalSectionTitle>Rental Summary</ModalSectionTitle>
                        </BtnWrapper>

                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Rent</ModalRowLabel>
                                    <ModalRowValue>
                                        ₹{tenant?.occupancy?.rent || 0}
                                    </ModalRowValue>
                                </FlexCol>

                                <FlexCol>
                                    <ModalRowLabel>Security Deposit</ModalRowLabel>
                                    <ModalRowValue>
                                        ₹{tenant?.occupancy?.security || 0}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>

                                {tenant?.advanceRentPaidAmount ?
                                    <FlexCol>
                                        <ModalRowLabel>Advance Rent Paid</ModalRowLabel>
                                        <ModalRowValue>
                                            ₹{tenant?.advanceRentPaidAmount}/
                                            <span className="text-gray-500 text-xs">{tenant?.advanceRentPaidMonths} month</span>
                                        </ModalRowValue>
                                    </FlexCol>
                                    :
                                    <FlexCol>
                                        <ModalRowLabel>Last Rent Paid</ModalRowLabel>
                                        <ModalRowValue>
                                            {tenant?.lastRentPaid
                                                ? moment(tenant?.lastRentPaid).format("DD, MMM YYYY")
                                                : "-"}
                                        </ModalRowValue>
                                    </FlexCol>
                                }
                                {tenant?.occupancy?.stayType !== Config.STAY_TYPE.SHORT &&
                                    <FlexCol>
                                        <ModalRowLabel>Rent Date</ModalRowLabel>
                                        <ModalRowValue>
                                            {tenant?.occupancy?.rentalCycle
                                                ? getOrdinalNumber(tenant.occupancy.rentalCycle) + ' of month'
                                                : "-"}
                                        </ModalRowValue>
                                    </FlexCol>
                                }
                                {tenant?.occupancy?.stayType === Config.STAY_TYPE.SHORT &&
                                    <FlexCol>
                                        <ModalRowLabel>Check-out Date</ModalRowLabel>
                                        <ModalRowValue>
                                            {tenant?.occupancy?.moveOutDate
                                                ? moment(tenant?.occupancy?.moveOutDate).format(
                                                "DD, MMM YYYY"
                                            )
                                                : "-"}
                                        </ModalRowValue>
                                    </FlexCol>
                                }
                            </ModalRow>
                        </ModalSection>


                        {/* Financial Summary */}
                        {/* <BtnWrapper>
                            <ModalSectionTitle>Financial Summary</ModalSectionTitle>
                        </BtnWrapper>

                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Total Paid</ModalRowLabel>
                                    <ModalRowValue>
                                        ₹{tenant?.totalCollection || 0}
                                    </ModalRowValue>
                                </FlexCol>

                                <FlexCol>
                                    <ModalRowLabel>Total Due</ModalRowLabel>
                                    <ModalRowValue>
                                        ₹{tenant?.totalDues || 0}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Pending Amount</ModalRowLabel>
                                    <ModalRowValue>
                                        ₹{tenant?.pendingAmount || 0}
                                    </ModalRowValue>
                                </FlexCol>

                                <FlexCol>
                                    <ModalRowLabel>Payment Status</ModalRowLabel>
                                    <ModalRowValue>
                                        {tenant?.paymentStatus || "Pending"}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Last Payment Date</ModalRowLabel>
                                    <ModalRowValue>
                                        {tenant?.lastPaymentDate
                                            ? moment(tenant?.lastPaymentDate).format(
                                                "DD, MMM YYYY"
                                            )
                                            : "-"}
                                    </ModalRowValue>
                                </FlexCol>

                                <FlexCol>
                                    <ModalRowLabel>Outstanding</ModalRowLabel>
                                    <ModalRowValue>
                                        ₹{tenant?.balance || 0}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                        </ModalSection> */}


                        {/* Dues Listing */}
                        {/* Dues Listing */}
                        <BtnWrapper>
                            <ModalSectionTitle>Dues Listing</ModalSectionTitle>
                        </BtnWrapper>

                        <ModalSection className="gap-0">
                            {tenant?.dues?.length > 0 ? (
                                tenant?.dues?.map((due, index) => (
                                    <div key={due?.id || index}>
                                        <div className="flex items-center justify-between py-3">

                                            {/* Left Side */}
                                            <div className="flex flex-col">
                                                <span className="text-sm font-semibold text-gray-900">
                                                    {getDueTypeLabel(due?.type) || due?.title || "Rent"}
                                                </span>

                                                <span className="text-xs text-gray-500 mt-0.5">
                                                    {due?.dueDate
                                                        ? moment(due?.dueDate).format(
                                                            "DD MMM YYYY"
                                                        )
                                                        : "-"}
                                                </span>
                                            </div>

                                            {/* Right Side */}
                                            <div className="flex flex-col items-end">
                                                <span className="text-xl font-semibold tracking-tight text-gray-900">
                                                    ₹{(
                                                        due?.balance ||
                                                        due?.amount ||
                                                        0
                                                    ).toLocaleString()}
                                                </span>

                                                <button
                                                    onClick={() => showPaymentLinkModal(due)}
                                                    className="mt-1 flex items-center gap-1.5
                                                        text-xs font-medium text-primary-color
                                                        hover:text-blue-700 transition-colors"
                                                >
                                                    {loadingId === due.id ? (
                                                        <div className="w-4 h-4 border-2 border-gray-300 border-t-transparent rounded-full animate-spin" />
                                                    ) : (
                                                        "Remind"
                                                    )}

                                                </button>
                                            </div>
                                        </div>

                                        {index !== tenant?.dues?.length - 1 && (
                                            <div className="border-b border-gray-100" />
                                        )}
                                    </div>
                                ))
                            ) : (
                                <div className="py-3 text-sm text-gray-500">
                                    No dues available
                                </div>
                            )}
                        </ModalSection>

                        {/* Documents */}
                        <BtnWrapper>
                            <ModalSectionTitle>Documents</ModalSectionTitle>
                        </BtnWrapper>

                        <ModalSection className="p-0 overflow-hidden">
                            {documents.length > 0 ? (
                                documents.map((doc, index) => (
                                    <div
                                        key={index}
                                        className={`flex items-center justify-between px-5 py-4 ${index !== documents.length - 1
                                            ? "border-b border-gray-100"
                                            : ""
                                            }`}
                                    >
                                        {/* Left Side */}
                                        <div className="flex items-center gap-4">

                                            {/* Icon */}
                                            <div
                                                className="h-12 w-12 rounded-2xl bg-[#E9EEF6]
                                                    flex items-center justify-center"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    className="h-6 w-6 text-[#2563EB]"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    stroke="currentColor"
                                                    strokeWidth={2}
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M9 12h6m-6 4h6M7 4h7l5 5v11a1 1 0 01-1 1H7a1 1 0 01-1-1V5a1 1 0 011-1z"
                                                    />
                                                </svg>
                                            </div>

                                            {/* Content */}
                                            <div className="flex flex-col">
                                                <span className="text-sm font-semibold text-gray-900">
                                                    {doc.label}
                                                </span>

                                                <span className="text-xs text-gray-500 mt-0.5">
                                                    {doc?.uploadedAt
                                                        ? `Uploaded ${moment(
                                                            doc.uploadedAt
                                                        ).format("DD MMM YYYY")}`
                                                        : "Uploaded"}
                                                </span>
                                            </div>
                                        </div>

                                        {/* Right Badge */}
                                        <Link
                                            to={doc.file}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="px-4 py-1.5 rounded-full
                                                bg-green-100 text-green-700
                                                text-sm font-semibold
                                                hover:bg-green-200 transition-colors"
                                        >
                                            {"Open"}
                                        </Link>
                                    </div>
                                ))
                            ) : (
                                <div className="px-5 py-6 text-sm text-gray-500 bg-[#F8F8F5]">
                                    No documents uploaded
                                </div>
                            )}
                        </ModalSection>
                    </Wrapper>
                </ScrollableContent>
            </ModalContent>
        </Container>
    );
};

export default TenantDetailsModal;

// ---------------- Styled Components ----------------
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;
